/* eslint-disable react/prop-types, react/jsx-props-no-spreading */
import React from 'react';
import noop from 'lodash/noop';

import { ContentModuleModal, SortableList } from '@molecules';
import { Typography } from '@atoms';
import { NO_MARGIN_BOTTOM } from '@constants';
import { getImage } from '@utils/media';

import Form from '../Form';

import SectionItem from './SectionItem';
import SectionForm from './SectionForm';
import CarouselItem from './Item';
import { SECTIONS, TABBED_PANEL_INITS, FORM_PANEL } from './constant';
import s from './styles.module.less';

const TabbedModule = ({ visible = true, previewImg, onSubmit, hide, onDelete, initialValues: initData, errors }) => {
  const [form] = Form.useForm(FORM_PANEL);

  const initialValues = React.useMemo(() => form.deserialize(initData || TABBED_PANEL_INITS), [form, initData]);

  const [slides, setSlides] = React.useState(initialValues[SECTIONS.name]);

  const syncSlides = React.useCallback(
    (_slides) => {
      form.setFields([{ name: SECTIONS.name, value: _slides }]);
      setSlides(_slides);
    },
    [form, setSlides],
  );

  const handleClose = () => {
    form.resetFields();
    hide();
  };

  const handleSubmit = (values) => {
    onSubmit(values);
    handleClose();
  };

  const handleAdd = React.useCallback((slide) => syncSlides([slide, ...(form.getFieldValue(SECTIONS.name) || [])]), [
    form,
    syncSlides,
  ]);

  return (
    <ContentModuleModal
      subtitle="A selection of tabbed pages with a featured image, title, copy There are 8 sections available to use."
      okText={onDelete ? 'SAVE CHANGES' : 'ADD TABBED MODULE'}
      heroImageSrc={previewImg}
      title="Tabbed Module"
      onCancel={handleClose}
      onSubmit={form.submit}
      onDelete={onDelete}
      visible={visible}
      errors={errors}
    >
      <Typography.Title level={3}>Add section</Typography.Title>
      {visible && <SectionForm onSubmit={handleAdd} className={s.addForm} initKey="mainForm" />}
      <SortableList
        style={NO_MARGIN_BOTTOM}
        label="Current sections"
        onChange={syncSlides}
        withPlaceholder
        value={slides}
        withCount
      >
        {(value, { edit, isEdit, save, buttons }) => {
          return (
            isEdit ? (
              <SectionForm onSubmit={save} initialValues={value} buttons={buttons} initKey={slides.indexOf(value)} />
            ) : (
              <SectionItem image={getImage(value, 'image')} description={value.subheadline} handleEdit={edit}>
                {value?.title}
              </SectionItem>
            ))
        }}
      </SortableList>

      <Form onSerializedFinish={handleSubmit} initialValues={initialValues} layout="vertical" form={form}>
        <Form.List className={s.listItem} {...SECTIONS}>
          {noop}
        </Form.List>
      </Form>
    </ContentModuleModal>
  );
};

TabbedModule.Item = CarouselItem;

export default TabbedModule;
